import { Pipe } from '@angular/core';

@Pipe({name: 'currency', pure: true, standalone: false})
export class T4DCurrencyPipe {
   transform(value: any, host: any): any {

     const fmt = host.currency_format,
           val = parseFloat(value),
           v = val.toLocaleString(fmt.locale.replace('_', '-'), {style: 'currency', currency: 'EUR'});
     // hackhackhack: we support custom currency symbols (e.g. "Fr." instead of "CHF"), but JS doesn't. So
     // we pretend to use EUR, then replace the symbol. This works for all our supported locales, but it might
     // not for others.
     return v.replace('EUR', host.currency_symbol).replace('€', host.currency_symbol);
   }
}
